import * as React from 'react';
import { mapTags, useTranslator } from '@gandi/translate';
import { Alert, Base, Choice, ChoiceGroup, Switch, Text } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const iconNameDict = {
  gc1: 'visa',
  gc2: 'americanexpress',
  gc3: 'mastercard',
  Visa: 'visa',
  MasterCard: 'mastercard',
  'American Express': 'americanexpress',
  mycard: 'cc'
  // XXX to be completed.
};
const iconNameFor = ({
  key,
  code,
  meanType
}) =>
// $FlowFixMe[invalid-computed-prop]
iconNameDict[key] ||
// $FlowFixMe[invalid-computed-prop]
meanType && iconNameDict[meanType] ||
// $FlowFixMe[invalid-computed-prop]
iconNameDict[code] || code;
export default function PaymentMethodChoice({
  onChange,
  disabled,
  paymentMethods,
  paymentMethodSave,
  prepaidAmount,
  currency,
  value,
  payBlock,
  onSaveMethodChange,
  saveMethod
}) {
  const {
    __,
    formatPrice
  } = useTranslator();

  // $FlowFixMe[missing-local-annot]
  const handleValueChange = selectedKey => {
    const method = paymentMethods?.find(({
      key
    }) => selectedKey === key);
    if (method) {
      onChange(method);
    }
  };
  const handleSaveMethodChange = evt => onSaveMethodChange(evt.target.checked);
  return /*#__PURE__*/_jsx(ChoiceGroup, {
    layout: "column",
    name: "paymentType",
    value: value?.key || '',
    onValueChange: handleValueChange,
    marginBottom: "small",
    children: paymentMethods?.map(({
      allow_recurrent: allowRecurrent,
      code,
      key,
      name_label: nameLabel,
      mean_type: meanType
    }) => /*#__PURE__*/_jsxs(React.Fragment, {
      children: [key !== 'prepaid' && /*#__PURE__*/_jsx(Choice, {
        disabled: disabled,
        icon: iconNameFor({
          key,
          code,
          meanType
        }),
        label: nameLabel,
        value: key
      }), key === 'prepaid' && /*#__PURE__*/_jsx(Choice, {
        disabled: disabled,
        icon: iconNameFor({
          key,
          code,
          meanType
        }),
        value: key,
        children: /*#__PURE__*/_jsxs(Base, {
          flex: true,
          flexJustifyBetween: true,
          gap: "xsmall",
          slot: "label",
          children: [/*#__PURE__*/_jsx(Text, {
            weight: "semibold",
            children: nameLabel
          }), ' ', prepaidAmount !== undefined && currency && /*#__PURE__*/_jsx("span", {
            children: __('Currently %(prepaid)s available', {
              prepaid: formatPrice(prepaidAmount, currency)
            })
          })]
        })
      }), key === value?.key && code !== 'mycard' && allowRecurrent && paymentMethodSave && /*#__PURE__*/_jsx(Base, {
        marginBottom: "xsmall",
        paddingX: "xsmall",
        children: /*#__PURE__*/_jsx(Switch, {
          name: "save",
          disabled: paymentMethodSave === 'mandatory' || disabled,
          checked: paymentMethodSave === 'mandatory' || saveMethod,
          onChange: handleSaveMethodChange,
          help: __('Your credit card details will be safely stored at our payment' + ' gateway and you can delete or modify them at any time.'),
          children: __('Save %(paymentMethod)s for future use', {
            paymentMethod: nameLabel
          })
        })
      }), key === value?.key && code === 'bitcoin' && /*#__PURE__*/_jsx(Alert, {
        withBackground: true,
        marginX: "xsmall",
        intent: "warning",
        title: __('Only for Bitpay "verified" accounts'),
        message: [__('Please note that our technical partner BitPay only authorizes payment for BitPay "Verified" accounts.'), mapTags(__('Further information is available via [[supportLink:]].'), () => ({
          supportLink: /*#__PURE__*/_jsx("a", {
            href: __('https://docs.gandi.net/en/billing/means_of_payment/bitcoin.html'),
            target: "gandi-doc",
            children: __('our online documentation')
          })
        }))]
      }), key === value?.key && key === 'transfer' && /*#__PURE__*/_jsx(Base, {
        tagName: "p",
        marginY: "none",
        marginX: "xsmall",
        children: __('You can pay for your order via bank transfer. Such payment will only ' + 'be taken into account following the reception of your payment, which ' + 'usually occurs 2 to 7 days after your order has been made.')
      }), key === value?.key && payBlock]
    }, key))
  });
}